import { getContent } from './confluence';

export const getParentID = (contentId) => {
	return getContent(contentId, {
		expand: 'container',
	}).then((data) => {
		if (typeof data.container !== 'undefined' && typeof data.container.id !== 'undefined') {
			return data.container.id;
		} else {
			// eslint-disable-next-line
			throw "There's no parent id available for the content id";
		}
	});
};
